import { Button, CheckboxGroup, RoundIcon, Typography } from '@ecdlink/ui';
import { useWindowSize } from '@reach/window-size';
import Clipboard from '@/assets/clipboardIcon.svg';
import { useState } from 'react';
import { getStringFromClassNameOrId } from '@ecdlink/core';
import { format } from 'date-fns';
import { useWalkthroughContext } from '@/context/walkthrougContext';
import { referralsSteps } from './steps';
import {
  DUMMY_MOTHER_FIRST_NAME,
  dummyMotherReferralsData,
} from '../../walkthrough/profile-dummy';

const HEADER_HEIGHT = 64;

export const ReferralsDummy: React.FC = () => {
  const { height } = useWindowSize();
  const [showSelected, setShowSelected] = useState(false);
  const [showBackReferrals, setShowBackReferrals] = useState(false);

  const { setState, state } = useWalkthroughContext();

  const walkthroughData = dummyMotherReferralsData;

  const nextWalkthroughStep = () => {
    if (state.tourActive) {
      if (state?.stepIndex === 0) {
        setShowSelected(true);
        setState({ stepIndex: 1 });
      } else if (state?.stepIndex === 1) {
        setShowBackReferrals(true);
        setState({ stepIndex: 2 });
      } else if (state?.stepIndex === 2) {
        setState({ stepIndex: 3 });
      }
    }
  };

  return (
    <>
      <div className="flex flex-col" style={{ height: height - HEADER_HEIGHT }}>
        {!showBackReferrals ? (
          <>
            <div className="bg-uiBg mt-14 flex items-center gap-2 p-4">
              <RoundIcon imageUrl={Clipboard} backgroundColor="tertiary" />
              <div>
                <Typography
                  type="h2"
                  align="left"
                  weight="bold"
                  color="textDark"
                  text={`Referrals for ${DUMMY_MOTHER_FIRST_NAME} `}
                />
                <Typography
                  className="col-span-2 row-span-2"
                  type="body"
                  align="left"
                  weight="skinny"
                  text={`2 referrals`}
                  color="textMid"
                />
              </div>
            </div>

            <div className="px-4 pb-4 pt-7">
              <Typography
                type="h4"
                align="left"
                weight="bold"
                text="Tap the boxes once you have made the referrals on paper"
                color="textDark"
                className="mb-4"
              />

              <Button
                text="Mark all as done"
                icon="CheckCircleIcon"
                type="filled"
                color="primary"
                textColor="white"
                className="mb-4 w-full"
                iconPosition="start"
              />

              {walkthroughData?.sections &&
                walkthroughData?.sections?.map((section, index) => (
                  <div className="flex flex-col gap-2" key={`section_` + index}>
                    <Typography
                      type="h3"
                      text={section.label}
                      color="textDark"
                    />
                    {walkthroughData?.questions?.clinicReferrals?.map(
                      (item: any, index) => (
                        <div
                          key={item?.id}
                          id={getStringFromClassNameOrId(
                            referralsSteps[0].target
                          )}
                        >
                          <CheckboxGroup
                            title={item?.comment}
                            titleColours="textMid"
                            name={section?.value}
                            value={item?.comment}
                            checked={index === 0 && showSelected}
                            onChange={nextWalkthroughStep}
                            description={format(
                              new Date(item.insertedDate),
                              'dd MMM yyyy'
                            )}
                          />
                        </div>
                      )
                    )}
                  </div>
                ))}

              <Button
                id={getStringFromClassNameOrId(referralsSteps[1].target)}
                text="Manage back-referrals"
                icon="ClipboardCheckIcon"
                type="outlined"
                color="primary"
                textColor="primary"
                className="mt-4 w-full"
                iconPosition="start"
                onClick={nextWalkthroughStep}
              />
            </div>
          </>
        ) : (
          <>
            <div className="bg-uiBg mt-14 flex items-center gap-2 p-4">
              <RoundIcon imageUrl={Clipboard} backgroundColor="tertiary" />
              <div>
                <Typography
                  type="h2"
                  align="left"
                  weight="bold"
                  color="textDark"
                  text={`Back-referrals for Lethabo `}
                />
                <Typography
                  className="col-span-2 row-span-2"
                  type="body"
                  align="left"
                  weight="skinny"
                  text={`1 back-referral to update`}
                  color="textMid"
                />
              </div>
            </div>

            {walkthroughData?.completedReferrals &&
              walkthroughData?.completedReferrals?.map((item, index) => (
                <div
                  className="my-4 flex items-center justify-between gap-3"
                  key={`Item_` + index}
                  id={getStringFromClassNameOrId(referralsSteps[2].target)}
                >
                  <div className="flex flex-col">
                    <Typography
                      type="body"
                      align="left"
                      weight="bold"
                      text={item?.comment || ''}
                      color="textDark"
                    />
                    <Typography
                      type="body"
                      align="left"
                      weight="skinny"
                      text={`Referred on ${format(
                        new Date(item.insertedDate),
                        'dd MMM yyyy'
                      )}`}
                      color="textMid"
                    />
                  </div>

                  <Button
                    text="Update"
                    icon="PencilIcon"
                    type="filled"
                    color="secondaryAccent2"
                    textColor="secondary"
                    className={`h-10 w-28`}
                    iconPosition="end"
                    onClick={nextWalkthroughStep}
                  />
                </div>
              ))}
          </>
        )}
      </div>
    </>
  );
};
